import { RequestConferenceWaitingRoom } from 'domain/usecases/conferenceWaitingRoom/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteRequestConferenceWaitingRoom
  implements RequestConferenceWaitingRoom
{
  private readonly url: string;

  private readonly httpClient: HttpClient<RequestConferenceWaitingRoom.Model>;

  constructor(
    url: string,
    httClient: HttpClient<RequestConferenceWaitingRoom.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  request = async (
    params: RequestConferenceWaitingRoom.Params,
  ): Promise<RequestConferenceWaitingRoom.Model> => {
    let query = '';
    if (params.query) {
      query = '?';
      Object.entries(params.query).forEach(([key, value]) => {
        query += `${key}=${value}&`;
      });
    }

    const httpResponse = await this.httpClient.request({
      url: `${this.url.replace(
        '{conferenceShort}',
        params.conferenceShort,
      )}${query}`,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
